module.exports = require('superagent-promise')(require('superagent'), Promise);
